<template>
  <!-- 退保申请 -->
  <el-dialog
    :visible.sync="visible"
    @close="closedig('form')"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    append-to-body
    width="60%"
  >
    <el-form ref="form" :model="form" label-width="100px" :rules="findRules">
      <div class="title">订单信息</div>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="订单号：">
            <el-input
              v-model="form.orderNum"
              disabled
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="保证金金额：">
            <el-input
              v-model="form.guaMoney"
              disabled
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="订单金额：">
            <el-input
              v-model="form.orderFee"
              disabled
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="项目名称：">
            <el-input
              v-model="form.projectName"
              disabled
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="标段名称：">
            <el-input v-model="form.bidName" disabled></el-input> </el-form-item
        ></el-col>
      </el-row>
      <div class="title">退保原因</div>
      <el-row>
        <el-col :span="24">
          <el-form-item label="退保原因：" prop="refundReason">
            <el-input
              type="textarea"
              :rows="4"
              maxlength="500"
              placeholder="请输入退保原因"
              v-model="form.refundReason"
            >
            </el-input> </el-form-item
        ></el-col>
      </el-row>
      <div class="title">身份验证</div>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="经办人：">
            <el-input
              v-model="form.operator"
              disabled="disabled"
            ></el-input></el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="经办人手机：">
            <el-input
              v-model="replacePhone"
              disabled="disabled"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="验证码：" prop="randCode">
            <el-input v-model="form.randCode" style="width: 63%"></el-input>
            <el-button
              @click="sendMsgTwo"
              :disabled="isDisabled2"
              style="
                background: #409eff;
                border: 0;
                color: #fff;
                margin-left: 20px;
                width: 30%;
              "
              >{{ code2 }}</el-button
            >
          </el-form-item></el-col
        >
      </el-row>

      <!-- <div
            style="text-align: center; margin-top: 20px; margin-bottom: 20px"
          >
            <el-button
              style="background: #0065b3; border: 0; color: #fff"
              @click="back"
              >返回</el-button
            >
            <el-button
              style="background: #0065b3; border: 0; color: #fff"
              @click="onSubmit('form')"
              >提交</el-button
            >
          </div> -->
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="info" @click="visible = false">返 回</el-button>
      <el-button type="primary" @click="onSubmit('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import { goRefund } from "../../apis/project/index";
export default {
  data() {
    return {
      code2: "立即获取",
      isDisabled2: false,
      ordinary: false,
      special: false,
      time: 119,
      form: {},
      phone: "",
      findRules: {
        refundReason: [
          { required: true, message: "请输入退保原因", trigger: "blur" },
        ],
        randCode: [
          { required: true, message: "请输入验证码", trigger: "blur" },
        ],
      },
      closePop: true,
      replacePhone: '',
      interval:null,
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: null,
    },
  },
  watch: {
    formData: {
      handler(v) {
        if (v) {
          this.form = v;
          let pat = /(\d{3})\d*(\d{4})/;
          this.phone = this.form.phone;
          this.replacePhone = this.form.phone.replace(pat, "$1****$2");
          this.code2 = '立即获取'
          this.isDisabled2=false
          window.clearInterval(this.interval);
        }
      },
    },
  },
  computed: {
    visible: {
      get() {
        return this.dialogVisible;
      },
      set(v) {
        this.$emit("update:dialogVisible", v);
      },
    },
  },
  created() {
    // this.form = this.formData;
    // let pat = /(\d{3})\d*(\d{4})/;
    // this.phone = this.form.phone;
    // this.form.phone = this.form.phone.replace(pat, "$1****$2");
  },
  methods: {
    sendMsgTwo() {
      // this.$refs.form.validateField("phone", (errorMsg) => {
      //   if (!errorMsg) {
      this.axios({
        method: "POST",
        url: "/loginController/getRCode",
        data: {
          checkFlag: "find",
          phoneNum: this.phone,
          from: "33",
        },
      }).then((res) => {
        if (res.data.status == 1) {
          let me = this;
          me.isDisabled2 = true;
          this.interval = window.setInterval(function () {
            me.code2 = me.time;
            --me.time;
            if (me.time < 0) {
              me.code2 = "重新发送";
              me.time = 119;
              me.isDisabled2 = false;
              window.clearInterval(this.interval);
            }
          }, 1000);
        } else {
          this.$message({
            message: res.data.statusInfo,
            type: "error",
          });
        }
      });
      // } else {
      // }
      // });
    },
    typeOne() {
      this.special = false;
      this.ordinary = !this.ordinary;
    },
    typeTwo() {
      this.ordinary = false;
      this.special = !this.special;
    },
    back() {
      this.$router.push("/order");
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          goRefund({
            refundReason: this.form.refundReason,
            randCode: this.form.randCode,
            insuranceId: Number(this.form.orderId),
            guarantorId:this.form.guarantorId=='3'?this.form.guarantorId:''
          }).then((res) => {
            if (res.data.status == 1) {
              this.visible = false;
              this.$emit("closePop", this.closePop);
              // this.$router.push("/surrender");
            } else {
              this.$message({
                message: res.data.statusInfo,
                type: "error",
              });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closedig() {
      this.form.randCode = "";
      this.form.refundReason = "";
    },
  },
  components: {},
};
</script>

<style scoped>
.page {
  background-color: #fff;
  height: 100%;
  /* margin: 0 20px; */
}
.elCard {
  background-color: #0065b3 !important;
  color: #fff;
}
</style>
